module.exports = __webpack_public_path__ + "img/9791156550143.31008ae3.jpg";